/**
 * http://confluence.mockuai.com/display/wdzgxcx/module_property%23title
 */
let config = [
  {
    name: '自定义菜单',
    type: 'module-name',
  },
  {
    key: 'property_data',
    name: '属性',
    type: 'custom',
    content: [
      {
        key: 'is_icon_show',
        name: '图标',
        type: 'radio-box',
        'radio-list': [
          {
            label: '显示文案',
            value: 0,
          },
          {
            label: '显示图片',
            value: 1,
          },
        ],
      },
      {
        key: 'icon_url',
        name: '图片',
        type: 'choose-photo',
      },
      {
        key: 'name',
        name: '文案',
        type: 'text',
        memo: '名称最多10个汉字',
        max: 10,
      },
      {
        key: 'sub_title',
        name: '小标题',
        type: 'text',
        memo: '小标题最多20个汉字',
        max: 20,
      },
      {
        key: 'radius_top',
        name: '上圆角',
        type: 'slider',
      },
      {
        key: 'radius_bottom',
        name: '下圆角',
        type: 'slider',
      },
      {
        key: 'margin_num',
        name: '左右间距',
        type: 'slider',
      },
      {
        key: 'link_data',
        name: '链接',
        type: 'link',
      },
    ],
  },
];
export default config;
